import _functionUncurryThis from "../internals/function-uncurry-this";
var exports = {};
var uncurryThis = _functionUncurryThis;
exports = uncurryThis([].slice);
export default exports;